import * as Sentry from '@sentry/browser';
import type { SeverityLevel } from '@sentry/types';

interface LogOptions {
  message: string;
  error?: unknown;
  context?: Record<string, unknown>;
}

type LogLevel = 'info' | 'warn' | 'error';

const mapLogLevelToSeverityLevel = (level: LogLevel): SeverityLevel => {
  const severityMap: Record<LogLevel, SeverityLevel> = {
    info: 'info',
    warn: 'warning',
    error: 'error',
  };
  return severityMap[level];
};

const logger = {
  log: (level: LogLevel, { message, error, context }: LogOptions) => {
    console.log(`[${level.toUpperCase()}]: ${message}`, error, context);

    if (level === 'error' && error) {
      Sentry.captureException(error, { extra: context });
    } else {
      Sentry.captureMessage(message, {
        level: mapLogLevelToSeverityLevel(level),
        extra: context,
      });
    }
  },
  info: (options: LogOptions) => logger.log('info', options),
  warn: (options: LogOptions) => logger.log('warn', options),
  error: (options: LogOptions) => logger.log('error', options),
};

export default logger;
